import { NgModule } from '@angular/core';
import { provideHotToastConfig } from '@ngxpert/hot-toast';

@NgModule({
  providers: [
    provideHotToastConfig({
      theme: 'snackbar',
      duration: 5000,
      position: 'top-center',
      visibleToasts: 3,
      stacking: 'depth',
      style: {
        padding: '12px 24px',
        fontSize: '16px',
      },
    }),
  ],
  exports: [],
})
export class SharedSnackbarModule {}
